module.exports = __webpack_public_path__ + "img/real-value.78018b2f.webp";